<template>
  <div class="py-2 container-fluid">
    <nps-navigator v-model="npsIndex" :title="npsTitle" :min="0" :max="items.length - 1" />
    <div class="row">
      <div class="col-md-9">
        <div class="row">
          <div class="col-md-8">
            <totais-nps-card title="Avaliações" :count="data.totais.avaliacoes" :possiveis="data.totais.possiveis" />
          </div>
          <div class="col-md-4">
            <nps-percentual-card :percentual="data.totais.nps" />
          </div>
          <div class="col-md-4 mt-sm-2">
            <pizza-nps-card title="Votos X Categoria" :series="data.avaliacoes" />
          </div>
          <div class="col-md-4 mt-sm-2">
            <pizza-nps-card title="% X Categoria" :series="data.percentuais" :is-percentual="true" />
          </div>
          <div class="col-md-4 mt-sm-2">
            <nps-zona-pontuacao-card :percentual="data.totais.nps" />
          </div>

        </div>
      </div>
      <div class="col-md-3">
        <pizza-nps-card title="Tipo Usuários" :series="data.tipoUsuarios" />
      </div>

    </div>
    <div class="mt-2 row">
      <div class="col-12">
        <div class="card">
          <div class="pb-0 card-header">
            <div class="row">
              <div class="col-6">
                <h5 class="mb-0">Avaliações({{ avaliacoesFiltered.length }})</h5>
              </div>
              <div class="col-6 d-flex justify-content-end">

                <button class="btn-actions" type="button">
                  <i class="fas fa-ellipsis-v" style="margin-right: 5px;"></i> Ações NPS

                  <div class="options-nps">

                    <div @click="fnInsereNovoNPS()">
                      <span> <i class="fas fa-plus"></i> Novo NPS</span>
                    </div>

                    <!-- <div data-bs-toggle="modal" data-bs-target="#modal-reprocessa-nps">
                      <span> <i class="fas fa-retweet"></i> Reprocessar NPS</span>
                    </div> -->

                    <div @click="exportData()" v-if="avaliacoesFiltered.length > 0">
                      <span> <i class="fas fa-file-csv"></i> Exportar CSV</span>
                    </div>

                  </div>
                </button>
              </div>
            </div>
            <div class="d-lg-flex">
              <div class="d-flex justify-content-between mt-2">
                <argon-button color="success" size="xs" :full-width="true"
                  :variant="status == 'promotor' ? 'contained' : 'outline'" class="me-2" @click="setStatus('promotor')">
                  Promotores
                </argon-button>
                <argon-button color="warning" size="xs" :full-width="true"
                  :variant="status == 'neutro' ? 'contained' : 'outline'" class="me-2" @click="setStatus('neutro')">
                  Neutros
                </argon-button>
                <argon-button color="danger" size="xs" :full-width="true"
                  :variant="status == 'detrator' ? 'contained' : 'outline'" @click="setStatus('detrator')">
                  Detratores
                </argon-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-9">
                <label>Pesquisar Cliente</label>
                <input class="form-control text-uppercase" v-model="search" placeholder="Usuário, Empresa, CPF">
              </div>
              <div class="col-3">
                <label>Tipo de Usuário</label>
                <select class="form-control" v-model="selectTipoUsuario">
                  <option :value="null">Todos</option>
                  <option v-for="tipoUsuario of listTipoUsuarios" :key="tipoUsuario.id" :value="tipoUsuario.id">
                    {{ tipoUsuario.descricao }}
                  </option>
                </select>
              </div>
            </div>
            <div class="table-responsive">
              <table id="cancelamentos-list" class="table table-flush">
                <thead class="thead-light">
                  <tr>
                    <th class="my-2 text-xs">Nome</th>
                    <th class="my-2 text-xs">Empresa</th>
                    <th class="my-2 text-xs">Data</th>
                    <th class="text-center my-2 text-xs">Nota</th>
                    <th class="text-center my-2 text-xs">Tipo Usuário</th>
                    <th class="text-center my-2 text-xs">Status</th>
                    <th class="text-center my-2 text-xs">Detalhes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item of avaliacoesFiltered" :key="item.id">
                    <td class="text-uppercase">
                      <span class="my-2 text-xs">
                        {{ item.usuario }}
                      </span>
                    </td>
                    <td>
                      <span class="my-2 text-xs">
                        {{ item.empresa }}
                      </span>
                    </td>
                    <td>
                      <span class="my-2 text-xs">
                        {{ filters.formatDate(item.data) }}
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="my-2 text-xs font-weight-bold">
                        {{ item.avaliacao }}
                      </span>
                    </td>
                    <td class="text-center">
                      <p>{{ item.descricao }}</p>
                    </td>
                    <td class="text-center">
                      <badge-status-nps :status="item.status" />
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-info btn-xs py-1 px-2" data-bs-toggle="modal"
                        data-bs-target="#modal-avaliacao-cliente" @click="setAvaliacao(item)">
                        Detalhes
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <table id="nps-table" class="table table-flush" :style="{ display: 'none' }">
    <thead class="thead-light">
      <tr>
        <th class="my-2 text-xs">Cód Empresa</th>
        <th class="my-2 text-xs">Nome Fantasia</th>
        <th class="my-2 text-xs">Usuário</th>
        <th class="my-2 text-xs">Data</th>
        <th class="text-center my-2 text-xs">Nota</th>
        <th class="text-center my-2 text-xs">Tipo Usuário</th>
        <th class="text-center my-2 text-xs">Status</th>
        <th class="text-center my-2 text-xs">Observações</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item of avaliacoesFiltered" :key="item.id">
        <td class="text-uppercase">
          <span class="my-2 text-xs">
            {{ item.empresa_id }}
          </span>
        </td>
        <td class="text-uppercase">
          <span class="my-2 text-xs">
            {{ item.empresa }}
          </span>
        </td>
        <td class="text-uppercase">
          <span class="my-2 text-xs">
            {{ item.usuario }}
          </span>
        </td>
        <td>
          <span class="my-2 text-xs">
            {{ filters.formatDate(item.data) }}
          </span>
        </td>
        <td class="text-center">
          <span class="my-2 text-xs font-weight-bold">
            {{ item.avaliacao }}
          </span>
        </td>
        <td class="text-center">
          <p>{{ item.descricao }}</p>
        </td>
        <td class="text-center">
          <badge-status-nps :status="item.status" />
        </td>
        <td>
          <span class="my-2 text-xs">
            {{ item.observacao }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
  <modal-avaliacao-cliente :avaliacao="avaliacao" />
  <modal-reprocessa-n-p-s />
</template>

<script>
import TotaisNpsCard from "./components/TotaisNpsCard.vue";
import NpsPercentualCard from "./components/NpsPercentualCard.vue";
import PizzaNpsCard from "./components/PizzaNpsCard.vue";
import NpsNavigator from "./components/NpsNavigator.vue";
import BadgeStatusNps from "./components/BadgeStatusNps.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ModalAvaliacaoCliente from "../../pages/components/ModalAvaliacaoCliente.vue";
import NpsZonaPontuacaoCard from "./components/NpsZonaPontuacaoCard.vue";
import api from "@/services/api";
import { exportToCSV } from "@/utils/export";
import { errorToast, showLoading, successToast } from '@/utils/alerts';
import moment from "moment";
import ModalReprocessaNPS from "../../pages/components/ModalReprocessaNPS.vue";

export default {
  name: "Nps",
  components: {
    PizzaNpsCard,
    BadgeStatusNps,
    TotaisNpsCard,
    NpsNavigator,
    ArgonButton,
    ModalAvaliacaoCliente,
    NpsPercentualCard,
    NpsZonaPontuacaoCard,
    ModalReprocessaNPS
  },
  data() {
    return {
      npsIndex: 0,
      status: '',
      search: '',
      items: [],
      avaliacao: null,
      avaliacoes: [],
      avaliacoesFiltered: [],
      selectTipoUsuario: null,
      listTipoUsuarios: [],
      data: {
        avaliacoes: [],
        percentuais: [],
        quantidades: [],
        totais: {
          avaliacoes: 0,
          possiveis: 0,
          percentual: 0,
          nps: 0,
        },
      },
    };
  },
  created() {
    this.getTipoUsuarios();
    this.fetchNps();
  },
  methods: {
    setStatus(status) {
      this.status = this.status == status ? '' : status;
    },
    setAvaliacao(item) {
      this.avaliacao = item;
    },
    getTipoUsuarios() {
      api.get('/tipo-usuario').then(({ data }) => {
        this.listTipoUsuarios = data;
      });
    },
    fetchNps() {
      api.get(`/nps`).then(({ data }) => {
        this.items = data;
        this.npsIndex = this.items.length - 1;
      });
    },
    fetchAvaliacoes() {
      const nps = this.items[this.npsIndex];

      api.get(`/nps/avaliacoes/${nps.id}`)
        .then(({ data }) => {
          this.avaliacoes = data;
          this.filterAvaliacoes();
        });
    },
    fetchData() {
      const nps = this.items[this.npsIndex];

      this.status = '';
      this.avaliacoes = [];
      this.avaliacoesFiltered = [];

      api.get(`/nps/data/${nps.id}`)
        .then(({ data }) => {
          this.data = data;
          this.fetchAvaliacoes();
        });
    },
    filterAvaliacoes() {
      const { status, avaliacoes, search, selectTipoUsuario } = this;

      let items = [
        ...avaliacoes
      ];

      if (search) {
        items = items.filter(item => item.search.toLowerCase().indexOf(search.toLowerCase()) > -1);
      }

      if (status) {
        items = items.filter(item => item.status == status);
      }

      if (selectTipoUsuario) {
        items = items.filter(item => item.tipo_usuario_id == selectTipoUsuario);
      }

      this.avaliacoesFiltered = items;
    },
    exportData() {
      const nps = this.items[this.npsIndex];
      exportToCSV('nps-table', `nps-${nps ? nps.id : '**'}.csv`);
    },
    fnInsereNovoNPS() {
      this.$swal({
        title: 'Novo NPS',
        text: 'Deseja realmente inserir um novo NPS?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        customClass: {
          confirmButton: "btn bg-success",
          cancelButton: "btn bg-danger",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.fnSalvaNps();
        }
      });
    },
    fnSalvaNps() {
      const loading = showLoading(`Enviando NPS, Aguarde...`);

      let objNps = {
        pergunta: 'De 0 a 10 qual a chance de você recomendar a Bitz a um amigo?',
        dataFinal: moment().add(7, 'days').format('YYYY-MM-DD')
      };

      api.post(`/nps`, objNps)
        .then(({ data }) => {

          let dtaFinal = moment(data.dataFinal).format('DD/MM/YYYY');
          successToast('NPS inserido com sucesso! Data final: ' + dtaFinal);

          loading.close();

        }).catch((error) => {
          errorToast(error.data.message ?? 'Erro ao salvar NPS');
          loading.close();
        });
    }
  },
  computed: {
    npsTitle() {
      const nps = this.items[this.npsIndex];

      if (!nps) {
        return 'NPS ***';
      }

      return `NPS ${nps.id} - (${this.filters.formatDate(nps.createdAt)} ~ ${this.filters.formatDate(nps.dataFinal)})`;
    },
  },
  watch: {
    npsIndex: function () {
      this.fetchData();
    },
    status: function () {
      this.search = '';
      this.filterAvaliacoes();
    },
    search: function () {
      this.filterAvaliacoes();
    },
    selectTipoUsuario: function () {
      this.filterAvaliacoes();
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-actions {
  padding: 0.5rem 2rem;
  font-size: 0.75rem;
  border-radius: 0.5rem;
  color: #5e72e4;
  border: 1px solid #5e72e4;
  display: inline-block;
  background-color: #fff;
  font-weight: 700;
  cursor: pointer;
}

.btn-actions:hover {
  color: #000000 !important;
}

.options-nps {
  position: absolute;
  display: none;
  border: 1px solid #5e72e4;
  margin-top: 10px;
  right: 15px;
  border-radius: 10px;
  background-color: #fff;
  width: auto;
  text-align: left;
}

.btn-actions:hover .options-nps {
  display: block;
}

.options-nps div {
  padding: 10px 17px 10px 17px;
  color: #404041;
}

.options-nps div:hover {
  cursor: pointer;
  background-color: #f0f0f0;
  border-radius: 10px;
}

.options-nps div span i {
  padding-right: 5px;
}
</style>